import React, { useEffect, useState } from 'react';
import styles from './index.module.less';
import { DownOutlined, UpOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { FaqTemplateDataModel } from '@/types/home';
import { useWindowSize } from 'react-use';
import { useUserProvider } from '@/context/UserProvider';
import { cn } from '@/lib/utils';

declare global {
  interface Window {
    triggerSignUp: () => void;
  }
}

const FAQContent = ({
  faqInfo,
  faqList,
  className,
}: {
  faqInfo?: {
    title?: string;
    desc?: string;
  };
  faqList?: FaqTemplateDataModel;
  className?: string;
}) => {
  const [selectIndex, setSelectIndex] = useState(-1);
  const { width } = useWindowSize();
  const { isLogin, onChangedLoginView, onOpenLoginModal } = useUserProvider();

  const [faqContent, setFaqContent] = useState<
    {
      category?: string;
      content_list?: {
        id?: number;
        answer?: string;
        question?: string;
      }[];
    }[]
  >(null);

  const [selectedContent, setSelectedContent] = useState<{
    category?: string;
    content_list?: {
      id?: number;
      answer?: string;
      question?: string;
    }[];
  }>(null);

  // const faqInfo = contentData?.contentInfo?.['section-faq'] ?? null;

  useEffect(() => {
    if (faqList?.has_category) {
      setFaqContent(faqList?.category_list);
      setSelectedContent(faqList?.category_list[0]);
    } else {
      const tempData = {
        category: '1',
        content_list: faqList?.content_list,
      };
      setFaqContent([tempData]);
      setSelectedContent(tempData);
    }
  }, [faqList]);

  useEffect(() => {
    setSelectIndex(-1);
  }, [selectedContent, faqContent]);

  React.useEffect(() => {
    window.triggerSignUp = () => {
      if (!isLogin) {
        onChangedLoginView(false);
        onOpenLoginModal(true);
      }
    };
  }, []);

  const getCurrentListContent = () => {
    return (
      <div className={styles.contentList}>
        {selectedContent?.content_list?.map((item, index) => (
          <div className={styles.contentItem} key={`${selectedContent?.category}-${index}-${item?.answer}`}>
            <div
              className={classNames(styles.contentItemTitle)}
              onClick={() => {
                if (index === selectIndex) {
                  setSelectIndex(-1);
                } else {
                  setSelectIndex(index);
                }
              }}
            >
              <h3 className={classNames([styles.subTitle, index === selectIndex && styles.selectedSubTitle])}>
                {item?.question}
              </h3>
              {index === selectIndex ? (
                <UpOutlined style={{ fontSize: '12px' }} />
              ) : (
                <DownOutlined style={{ fontSize: '12px' }} />
              )}
            </div>
            {selectIndex === index && (
              <div className={styles.subDesc} dangerouslySetInnerHTML={{ __html: `<div>${item?.answer}</div>` }} />
            )}
          </div>
        ))}
      </div>
    );
  };

  const getContent = () => {
    return faqList?.content_list?.length > 0 || faqList?.category_list?.length > 0 ? (
      <div className={cn(styles.content, className)}>
        {faqInfo?.title && <h2 className={styles.title}>{faqInfo?.title}</h2>}

        {faqInfo?.desc && <p className={styles.desc}>{faqInfo?.desc}</p>}

        {faqContent?.length > 1 ? (
          <div className={styles.faqContent}>
            <div className={styles.categoryContent}>
              {faqContent?.map((item, index) => {
                return (
                  <div key={item?.category}>
                    <div
                      className={classNames(
                        styles.categoryItem,
                        item?.category === selectedContent?.category && styles.categoryItemActive
                      )}
                      onClick={() => {
                        if (item?.category !== selectedContent?.category) {
                          setSelectedContent(item);
                        }
                      }}
                    >
                      <span className={styles.categoryItemTitle}>{item.category}</span>
                    </div>
                    {item?.category === selectedContent?.category && width < 768 && getCurrentListContent()}
                  </div>
                );
              })}
            </div>

            {width > 768 && getCurrentListContent()}
          </div>
        ) : (
          <div className={styles.faqContent}>{getCurrentListContent()}</div>
        )}
      </div>
    ) : null;
  };

  return <>{getContent()}</>;
};

export default FAQContent;
